<template>
    <div class="tabs" :class="{class: true}">
        <header class="tabs__head mb-24" :class="{ 'has-caption': caption }">
            <h2 class="tabs__caption" v-html="caption" v-if="caption"></h2>

            <div class="tabs__content">
                <ul class="tabs__list">
                    <li v-for="(tab, index) in sortedTabs" v-html="tab.title" :class="{ 'tabs__item': true, 'is-active': (index === selectedIndex) }" :key="index" @click="selectTab(index, tab.title)">
                    </li>
                </ul>
            </div>
        </header>

        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        caption: {
            default: null,
            type: String
        },
        reset: {
            type: Boolean,
            default: false
        },
        class: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            selectedIndex: 0,
            tabs: []
        }
    },
    created() {
        this.tabs = this.$children;
    },
    mounted() {
        this.selectTab(0, this.tabs[0].title);
    },
    computed: {
      sortedTabs() {
        return this.tabs.sort((a, b) => a.$attrs.order - b.$attrs.order);
      }
    },
    methods: {
        selectTab(i, tabTitle) {
            this.$emit('clickOnTitle', i, tabTitle)

            this.selectedIndex = i;

            this.tabs.forEach((tab, index) => {
                tab.isActive = (index === i);
            });
        }
    },
    watch: {
        reset: function (val) {
            if (val) {
                this.selectTab(0, this.tabs[0].title)
            }
        }
    }
}
</script>
